import './styles/common.scss'
import './styles/login.scss'
import { ApiCalls } from "./libs/api_calls";
import { CookieBytes } from "./libs/cookieManager";
import { NotificationLib } from './libs/notification/NotificationLib.js';

import {getBackendUrl, getApiObject, initSession, getParamVaue, getUserDetailsFromCookies, loadVersion} from "./common.js";

var Notification = new NotificationLib();
const cookieManager = new CookieBytes();

var backend_url = undefined;
var api = undefined;

var loginForm     = undefined;
var usernameField = undefined;
var passwordField = undefined;
var accountField = undefined;

var logoutDialog = undefined;
var createAccountDialog = undefined;
var userDetails = undefined;

const commonHeaders = {
	"Content-Type": "application/json"
};

var loginLink = undefined;

var validateLogin = function (response) {
    if (response.status == true) {
            console.log("Login Success!. Saving session.");

            cookieManager.set("account", response.data.account, 1);
            cookieManager.set("username", response.data.username, 1);
            cookieManager.set("token", response.data.token, 1);
            cookieManager.set("session_type", response.data.type, 1);

            Notification.notify("success", "Login Successful. Redirecting to dashboard.")
            setTimeout(function(){
                window.location = "/dashboard.html";
            }, 1000)

    } else {
            let message = "Login Failed.";
            if (response.message){
                    message = response.message;
            }
            console.log(message);
            Notification.notify("error", message);
    }
}

function initUi() {
    loginLink = document.getElementById("login_link");
    loginForm     = document.getElementById("login_form");
    accountField = loginForm.querySelector("#account");
    usernameField = loginForm.querySelector("#username");
    passwordField = loginForm.querySelector("#password");

    logoutDialog = document.getElementById("logoutDialog");
    createAccountDialog = document.getElementById("createAccountDialog");

    loginLink.addEventListener("click", (e) => {
        e.preventDefault();
        const enteredUsername = usernameField.value;
        const enteredPassword = passwordField.value;
        const enteredAccount = accountField.value;

        if (!enteredAccount || !enteredUsername || !enteredPassword) {
            displayMessage("Please fill account, username and password fileds.", "red");
        } else {
            const loginData = {
                account : enteredAccount,
                username: enteredUsername,
                password: enteredPassword,
            };
            api.postData("/admin/login", commonHeaders, [], loginData, validateLogin);
        }
    });
}

var accountid = undefined;
var refer = undefined;
var account_type = undefined;


function showLogoutDialog(accountid) {
    console.log("You will be logged out from "+accountid+".");
    loginForm.style.display = "none";
    logoutDialog.style.display = "block";
    
    let ltext = logoutDialog.querySelector("p#logoutText");
    ltext.innerHTML = "Logout from "+accountid+" to proceed login to new account."

}

function loginSequence(accountid, email) {
    console.log("Starting Login Sequence.");
    let account_field = loginForm.querySelector("#account");
    let username_field = loginForm.querySelector("#username");

    
    account_field.value = accountid || "";
    username_field.value = email || userDetails.username || "";
}

function initLogic() {
    account_type = getParamVaue("account_type") || "user";
    accountid = getParamVaue("account");
    refer = getParamVaue("refer");

    if (accountid === null) {
        console.log("Account id not given in the url param.");
    }

    if (refer == "register_page") {
        console.log("Refered from registeration page. prefilled login.");
        let email = atob(getParamVaue("email"));
        loginSequence(accountid, email);
        return;
    }

    userDetails = getUserDetailsFromCookies();

    let cookie_accountid = userDetails.account;
    console.log("Account info from cookies. "+cookie_accountid);
    
    if (cookie_accountid === null) {
        console.log("No saved accounts. Normal login.");
        createAccountDialog.style.display = "block";
        loginSequence();
        return;
    }

    if (cookie_accountid != accountid) {
        showLogoutDialog(accountid);
    } 
    
    console.log("Found saved account. Continue to login.");
    loginSequence(accountid);
}

window.onload = function() {
    loadVersion()
	backend_url = getBackendUrl();

    if (!backend_url) {
        console.error("Unable to set backend url. Exitting.");
        return;
    }

    console.log("Backend URL is set. "+backend_url);

    api = getApiObject(backend_url);
	initSession();
    initUi();
    initLogic();
}